var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('OzOverlay',{staticClass:"flex justify-center items-center font-sans",on:{"scrim-click":_vm.cancel,"scrim-esc":_vm.cancel}},[_c('OzBaseDialogBox',{staticClass:"mx-7",attrs:{"buttons":[
      {
        text: _vm.__('Grant access'),
        emit: 'proceed',
        colorScheme: _vm.OzContainedButtonColorScheme.Primary,
      },
      {
        text: _vm.__('Cancel'),
        emit: 'cancel',
        colorScheme: _vm.OzContainedButtonColorScheme.Secondary,
      } ]},on:{"cancel":_vm.cancel,"proceed":_vm.proceed}},[_c('div',{staticClass:"text-center px-4 pt-6"},[_c('img',{staticClass:"select-none",attrs:{"src":_vm.iconUrl,"width":"64","height":"64","alt":_vm.__('Location services')}}),_vm._v(" "),_c('div',{staticClass:"font-semibold text-heading-3"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"m-4 text-body-small-posts"},_vm._l((_vm.body),function(content,index){return _c('p',{key:index},[_vm._v(_vm._s(content))])}),0)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }